export default "__VITE_ASSET__cDSE__gM__"